export const buildSampleSchema = ({
  entityName,
  columns,
  sampleRows,
  type = "source",
}) => {
  if (!columns) return null;
  if (type === "source" && !sampleRows) return null;

  const normalizeType = (colType) => {
    if (!colType) return "string";

    const t = String(colType).toLowerCase();
    if (t.includes("int")) return "integer";
    if (t.includes("double") || t.includes("decimal") || t.includes("float") || t.includes("numeric"))
      return "double";
    if (t.includes("timestamp")) return "timestamp";
    if (t.includes("date")) return "date";
    if (t.includes("bool")) return "boolean";

    return "string";
  };

  const formattedColumns = columns.map((col) => ({
    column_name: col.name || col.column_name,
    data_type: normalizeType(col.type || col.data_type),
  }));

  const result = {
    [type === "source" ? "source_name" : "destination_name"]: entityName,
    schema: { columns: formattedColumns },
  };
  if (sampleRows && sampleRows.length > 0) {
    result.sample_rows = sampleRows.slice(0, 3);
  }
  return result;
};

export const buildProfileData = ({
  entityName,
  columns,
  sampleRows,
  type = "source",
}) => {
  if (!columns || !sampleRows) return null;

  const normalizeType = (type) => {
    if (!type) return "string";

    const t = type.toLowerCase();
    if (t.includes("int")) return "integer";
    if (t.includes("double") || t.includes("decimal") || t.includes("float") || t.includes("numeric"))
      return "double";
    if (t.includes("timestamp")) return "timestamp";
    if (t.includes("date")) return "date";
    if (t.includes("bool")) return "boolean";

    return "string";
  };

  const profiledColumns = columns.map((col) => {
    const colName = col.name || col.column_name;
    const dataType = normalizeType(col.type || col.data_type);

    const values = sampleRows.map((row) => row[colName]);

    const nullCount = values.filter(
      (v) => v === null || v === undefined || v === ""
    ).length;

    const distinctCount = new Set(
      values.filter((v) => v !== null && v !== undefined && v !== "")
    ).size;

    const numericValues = values
      .map((v) => Number(v))
      .filter((v) => !Number.isNaN(v));

    return {
      column_name: colName,
      data_type: dataType,
      null_count: nullCount,
      distinct_count: distinctCount,
      ...(numericValues.length > 0 && {
        min: Math.min(...numericValues),
        max: Math.max(...numericValues),
      }),
    };
  });

  return {
    [type === "source" ? "source_name" : "destination_name"]: entityName,
    columns: profiledColumns,
  };
};

